const filters = {
  removeCurrencyFraction: (number, locale, currencyCode) => {
    if (!Intl || !Intl.NumberFormat.prototype.formatToParts) {
      // If the browser doesn't support splitting by currency parts, simply return a standard currency formatting.
      // In this case, $5.00 will remain as $5.00 where as browsers that support formatToParts will return $5
      const formattedNumberString = Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currencyCode,
      }).format(number)

      // As a short-term solution, remove any zero cent values from currencies that use a period as a decimal
      return formattedNumberString.replace('.00', '')
    } else {
      const formatter = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currencyCode,
        minimumFractionDigits: 0,
      })

      const numberString = formatter
        .formatToParts(number)
        .map(({ type, value }) => {
          switch (type) {
            case 'fraction': {
              // Add back the zero for any fractional parts that are a single digits in order to show fractional parts at two places
              return _.padEnd(value, 2, '0')
            }
            case 'decimal': {
              // Only show the decimal separator if the fractional part is not zero
              const fractionPart = (number - Math.floor(number)).toFixed(2)
              if (number !== 0) {
                return value
              } else {
                return fractionPart
              }
            }
            default:
              return value
          }
        })
        .reduce((string, part) => string + part)

      return !isNaN(numberString) ? number : numberString
    }
  },
}

export function installPricingFilters(vue) {
  Object.entries(filters).forEach(([key, value]) => {
    console.log(`adding filter [${key}]`)
    vue.filter(key, value)
  })
}
